import { useSelector } from 'react-redux'
import { selectVehiclesMapStyles } from '@/features/domain/ui'

export const useVehiclesMapStyle = () => {
  const { mode, custom } = useSelector(selectVehiclesMapStyles)

  if (Object.keys(custom).length > 0) return

  return mode
}
